import React from 'react';
import { useExportJobs, dismissExportJob } from './exportJobs';
import '../../styles/BackgroundExports.css';

/**
 * The page-level progress of BOM / ECO / Product structures exports whose window was closed
 * (or is still open) — one chip each, bottom centre, clear of the credits (nav) and the
 * support launcher (bottom right). Rendered once in App so it survives moving between pages.
 */
export default function BackgroundExports() {
  const jobs = useExportJobs();
  if (!jobs.length) return null;
  return (
    <div className="bgx-stack" role="status" aria-live="polite">
      {jobs.map((j) => (
        <div key={j.id} className={`bgx-chip bgx-chip--${j.status}`}>
          {j.status === 'running' && <span className="bgx-spin" aria-hidden="true" />}
          {j.status === 'done' && <span aria-hidden="true">✓</span>}
          {j.status === 'error' && <span aria-hidden="true">⚠</span>}
          <span className="bgx-text">
            {j.status === 'running' && <>Exporting <strong>{j.name}</strong>{j.total ? ` — ${j.done} / ${j.total}` : '…'}</>}
            {j.status === 'done' && <>Exported <strong>{j.name}</strong> — see your downloads</>}
            {j.status === 'error' && <>Export of <strong>{j.name}</strong> failed: {j.error}</>}
          </span>
          {j.status !== 'running' && (
            <button type="button" className="bgx-close" onClick={() => dismissExportJob(j.id)} aria-label="Dismiss">✕</button>
          )}
          {j.status === 'running' && j.total > 0 && (
            <i className="bgx-bar" style={{ width: `${Math.round((100 * j.done) / j.total)}%` }} />
          )}
        </div>
      ))}
    </div>
  );
}
